import { createSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import getLocalized from 'utils/get-localized';
import Platform from 'platform';
import keys from 'config/keys';

export const selectMatchFromProps = (_state, props) => props.match;
export const selectDetails = state => state.details;
export const selectParentalControl = state => state.parental.data.isParentalEnabled;
export const selectParentalControlAge = state => state.parental.data.age;

export const selectBackButtonKeyCode = () => Platform.getKeyCode(keys.BACK);

export const selectContentIdFromProps = createSelector(
  selectMatchFromProps,
  match => get(match, 'params.contentId', null),
);

export const selectContentTypeFromProps = createSelector(
  selectMatchFromProps,
  match => get(match, 'params.contentType', null),
);

export const selectSeasons = createSelector(
  selectContentIdFromProps,
  selectDetails,
  (contentId, details) => {
    return get(details, [contentId, 'data', 'seasons'], [])
      .filter(season => !isEmpty(get(season.episodes, ['content'])))
      .map(list => {
        const title = getLocalized(list.titles, get(list, 'titles.UA.title', list.title));
        const listId = list.id;
        let items = get(list.episodes, ['content'], null);
        const listType = 'LARGE';
        const hideShowMore = list.carouselTag === 'HIDE_SHOW_MORE';
        const data = { ...list, listId, title, items, listType, hideShowMore };
        return data;
      });
  },
);

export const selectCollectionId = createSelector(
  selectContentIdFromProps,
  contentId => `seasons-${contentId}`,
);

export const selectCollectionTitle = createSelector(
  selectDetails,
  selectContentIdFromProps,
  (details, contentId) => {
    const data = get(details, [contentId, 'data']);
    return data && getLocalized(data.titles, get(data, 'titles.UA.title', data.title));
  },
);
